import React from "react";
import { Routes, Route } from "react-router-dom";
import Invitation from "./pages/Invitation";
import InviteSuccess from "./pages/InviteSuccess";
import InviteFail from "./pages/InviteFail";
import PetMoment from "./pages/PetMoment";
import AboutUs from "./pages/AboutUs";
import {
  AppPermissionList,
  ChildrenPrivacyPolicy,
  MembershipServiceAgreement,
  PersonalInfoCollectionList,
  PersonalInfoSharingList,
  PetAIServiceAgreement,
  PrivacyPolicy,
  PrivacyPolicySummary,
  UserAgreement,
} from "./pages/agreements";

function App() {
  return (
    <Routes>
      <Route path="/family/invite" element={<Invitation />} />
      <Route path="/invite/success" element={<InviteSuccess />} />
      <Route path="/invite/fail" element={<InviteFail />} />
      <Route path="/pet/moment" element={<PetMoment />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route
        path="/privacy-policy/summary"
        element={<PrivacyPolicySummary />}
      />
      <Route
        path="/privacy-policy/personal-info-collection-list"
        element={<PersonalInfoCollectionList />}
      />
      <Route
        path="/privacy-policy/personal-info-sharing-list"
        element={<PersonalInfoSharingList />}
      />
      <Route
        path="/privacy-policy/children"
        element={<ChildrenPrivacyPolicy />}
      />
      <Route path="/user-agreement" element={<UserAgreement />} />
      <Route
        path="/user-agreement/pet-ai-service"
        element={<PetAIServiceAgreement />}
      />
      <Route
        path="/user-agreement/membership"
        element={<MembershipServiceAgreement />}
      />
      <Route path="/about-us" element={<AboutUs />} />
      <Route
        path="/privacy-policy/app-permission-list"
        element={<AppPermissionList />}
      />
    </Routes>
  );
}

export default App;
